import {
    FaPassport,
    FaFileAlt,
    FaBriefcase,
    FaGraduationCap,
    FaPlane,
    FaGlobe,
    FaKaaba,
    FaUserTie
} from 'react-icons/fa';

export const servicesData = [
    {
        id: 1,
        title: "Visit Visa File Preparation",
        icon: FaPassport,
        description: "Complete visit visa documentation and file preparation services",
        features: [
            "ID / CNIC",
            "Passport",
            "White background picture",
            "NOC or Company Registration (CR)",
            "Bank statement",
            "Family Registration Certificate (FRC)",
            "Marriage Registration Certificate (MRC)"
        ],
        color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
        id: 2,
        title: "Work Visa File + Interview Preparation",
        icon: FaBriefcase,
        description: "Comprehensive work visa processing with professional interview coaching",
        features: [
            "ID / CNIC",
            "Passport",
            "Professional photograph",
            "Work permit documentation",
            "Interview preparation sessions",
            "Mock interviews",
            "Document verification"
        ],
        color: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    {
        id: 3,
        title: "USA Student Visa (F1 Category)",
        icon: FaGraduationCap,
        description: "Expert guidance for USA F1 student visa applications",
        features: [
            "F1 visa application assistance",
            "I-20 form guidance",
            "SEVIS fee payment support",
            "Interview preparation",
            "Document checklist",
            "University admission support"
        ],
        color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    },
    {
        id: 4,
        title: "USA Visit Visa (B1/B2 Category)",
        icon: FaPlane,
        description: "Complete support for USA tourist and business visa applications",
        features: [
            "B1/B2 visa application",
            "DS-160 form filling",
            "Interview scheduling",
            "Document preparation",
            "Interview coaching",
            "Application tracking"
        ],
        color: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
    },
    {
        id: 5,
        title: "Australia Visit Visa (Subclass 600)",
        icon: FaGlobe,
        description: "Professional assistance for Australia tourist visa applications",
        features: [
            "Subclass 600 visa processing",
            "Online application support",
            "Document preparation",
            "Health insurance guidance",
            "Travel itinerary planning",
            "Application follow-up"
        ],
        color: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
    },
    {
        id: 6,
        title: "Study Visa - European Countries",
        icon: FaUserTie,
        description: "Study visa services for Ireland, Austria, Spain, and Portugal",
        features: [
            "Ireland study visa",
            "Austria study visa",
            "Spain study visa",
            "Portugal study visa",
            "University selection",
            "Admission assistance",
            "Visa application support"
        ],
        color: "linear-gradient(135deg, #30cfd0 0%, #330867 100%)"
    },
    {
        id: 7,
        title: "Visit Visa - All Countries",
        icon: FaGlobe,
        description: "Comprehensive visit visa services for destinations worldwide",
        features: [
            "Europe Schengen visa",
            "UK visit visa",
            "Canada visitor visa",
            "Dubai/UAE visa",
            "Malaysia, Singapore, Thailand",
            "Turkey, Egypt, and more",
            "Complete documentation support"
        ],
        color: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    },
    {
        id: 8,
        title: "Umrah Package",
        icon: FaKaaba,
        description: "Complete Umrah visa and travel package services",
        features: [
            "Umrah visa processing",
            "Flight booking assistance",
            "Hotel accommodation",
            "Transportation in Saudi Arabia",
            "Group packages available",
            "Spiritual guidance",
            "Complete travel support"
        ],
        color: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)"
    }
];
